

// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';

export default class WalletWalletsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'wallet-wallets';
        this.Server = this.props.context.getState().server.walletWallets;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['uuid', 'publicAddress'];

        const defaultHead = [
            {
                id: 'uuid',
                label: 'uuid',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'userId',
                label: 'user',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'walletUsers',
                object: 'user',
                show: 'email'
            },
            {
                id: 'chainId',
                label: 'chain',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'chains',
                object: 'chain',
                show: 'name'
            },
            {
                id: 'publicAddress',
                label: 'publicAddress',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}

